class CollectionPagination extends HTMLElement {
  constructor() {
    super();

    this.triggers = this.querySelectorAll('.js-pagination-trigger');

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.handleClick(trigger));
    });

    this.pages = document.querySelector('[data-pagination-loaded]').getAttribute('data-pagination-loaded')
  }

  handleClick(el) {
    el.classList.add('loading')
    let pageNumber = el.getAttribute('data-next-page') || el.getAttribute('data-prev-page'),
      pagePrev = el.getAttribute('data-prev-page'),
      pagePath = window.location.href,
      initialPage = parseInt(document.querySelector('[data-pagination-initial]').getAttribute('data-pagination-initial')),
      mainUrl = '',
      maxPage = parseInt(document.querySelector('[data-pagination-max]').getAttribute('data-pagination-max'));

    let pageLoaded = pageNumber
    let allPagesLoaded = this.pages.split(',').sort()
    let amountPagesLoaded = this.pages.split(',').length - 1

    if (pageNumber <= allPagesLoaded[amountPagesLoaded] && !pagePrev) {
      let pageToLoad = parseInt(allPagesLoaded[amountPagesLoaded]) + 1
      pageLoaded = pageToLoad
    } else if (pagePrev && pageNumber >= allPagesLoaded[0]) {
      let pageToLoad = parseInt(allPagesLoaded[0]) - 1
      pageLoaded = pageToLoad
    }

    document.querySelector('[data-pagination-loaded]').setAttribute('data-pagination-loaded', this.pages + ',' + pageLoaded)

    if (pagePath.includes('page=')) {
      var url = new URL(pagePath);
      var search_params = url.searchParams;

      // new value of "id" is set to "101"
      search_params.set('page', pageLoaded);

      // change the search property of the main url
      url.search = search_params.toString();

      // the new url string
      mainUrl = url.toString();
    } else if (pagePath.includes('?')) {
      mainUrl = pagePath + '&page=' + pageLoaded
    } else {
      mainUrl = pagePath + '?page=' + pageLoaded
    }

    let sectionId = document.querySelector('[data-pagination-section]').getAttribute('data-pagination-section')
    let urlToRequest = mainUrl + '&section_id=' + sectionId

    fetch(urlToRequest)
      .then(response => response.text())
      .then(data => {

        let dataHtml = new DOMParser().parseFromString(data, "text/html"),
          results = dataHtml.querySelector('.js-product-grid').childNodes,
          paginationPrev = dataHtml.querySelector('.js-pagination-ajax-previous'),
          paginationNext = dataHtml.querySelector('.js-pagination-ajax-next');

        if (results) {

          if (pagePrev) {
            // results need to be reversed here to not end up with products in the wrong order
            while (results.length > 0) {
              document.querySelector('.js-product-grid').prepend(results[results.length - 1]);
            }
          } else {
            while (results.length > 0) {
              document.querySelector('.js-product-grid').append(results[0]);
            }
          }

          // update pagination
          document.querySelector('.js-pagination-ajax-previous').replaceWith(paginationPrev);
          document.querySelector('.js-pagination-ajax-next').replaceWith(paginationNext);

          // if we arrived from the first page of results, never show the load previous button
          if (initialPage == 1) {
            document.querySelector('.js-pagination-ajax-previous [data-prev-page]').remove();
          }

          //if last page has been loaded, don't show the next button
          if (allPagesLoaded.includes(maxPage.toString())) {
            document.querySelector('.js-pagination-ajax-next [data-next-page]').remove();
          }

          // Events
          window.history.pushState('', '', mainUrl);
        }
      }).finally(() => {
        el.classList.remove('loading')
      });
  }
}

customElements.define('collection-pagination', CollectionPagination);
